import { AxiosError } from 'axios'
import { flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils/storeHelpers/storagePageSizeConstant'

import { TreatmentCategory } from 'Portals/Customer/entities'
import { TreatmentCategoryRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

export class TreatmentCategoryTable extends TableStore<TreatmentCategory.Basic> {
	constructor(public rootStore: RootStore) {
		super(storagePageSizeConstant('treatmentCategory'))
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				defaultSort,
				repository: TreatmentCategoryRepo.getList
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}
}
